'use strict'

import initVueInstances from './vue'
import initModals from './modals'

export {
	initVueInstances,
	initModals,
}
